"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utcToZonedTimeOrDefault = utcToZonedTimeOrDefault;
const date_fns_tz_1 = require("date-fns-tz");
const getAdjustedTimezone_1 = require("./getAdjustedTimezone");
function utcToZonedTimeOrDefault(date, timezone) {
    const adjustedTimezone = (0, getAdjustedTimezone_1.getAdjustedTimezone)(timezone);
    const zonedTime = (0, date_fns_tz_1.utcToZonedTime)(date, adjustedTimezone);
    if (!zonedTime?.getTime()) {
        console.error(`Timezone "${adjustedTimezone}" not supported. Date: "${date}", Zoned: "${zonedTime}"`);
        return new Date(date);
    }
    return zonedTime;
}
//# sourceMappingURL=utcToZonedTimeOrDefault.js.map